export enum MatchStatusEnum {
  Upcoming = "SCHEDULED",
  Live = "IN_PROGRESS",
  Halted = "PAUSED",
  Finished = "COMPLETED",
  Aborted = "CANCELED",
}
